import React, { useEffect, useState } from 'react';
import { Alert, Button, Input, Space, Typography } from 'antd';
import CustomDrawer from 'components/shared-components/CustomDrawer';
import { parseScreensImport } from 'utils/metaFlowImportExport';

const { TextArea } = Input;
const { Text, Paragraph } = Typography;

const FlowScreensImportDrawer = ({ open, onClose, onImport }) => {
  const [jsonText, setJsonText] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open) {
      setJsonText('');
      setError(null);
    }
  }, [open]);

  const handleImport = () => {
    try {
      setError(null);
      const result = parseScreensImport(jsonText);
      onImport(result);
      onClose();
    } catch (err) {
      setError(err.message || 'Failed to import');
    }
  };

  return (
    <CustomDrawer
      title="Import flow screens"
      open={open}
      onClose={onClose}
      width={560}
      destroyOnClose
      footer={
        <Space style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" onClick={handleImport}>
            Import
          </Button>
        </Space>
      }
    >
      <Paragraph type="secondary" style={{ marginBottom: 12 }}>
        Paste a JSON export from this builder (screens, fields, and filled values). This replaces
        the current screens in the editor — save draft to persist.
      </Paragraph>

      <Text type="secondary" style={{ fontSize: 12, display: 'block', marginBottom: 6 }}>
        JSON
      </Text>
      <TextArea
        value={jsonText}
        onChange={(e) => setJsonText(e.target.value)}
        rows={18}
        placeholder='{ "format": "waba_meta_flow_screens", "screens": [ ... ] }'
        style={{ fontFamily: 'monospace', fontSize: 12 }}
      />

      {error ? (
        <Alert
          type="error"
          showIcon
          style={{ marginTop: 12 }}
          message={error}
        />
      ) : null}
    </CustomDrawer>
  );
};

export default FlowScreensImportDrawer;
